import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivable.DeleteChequeDocument.IRequest;
type Response = Api.Finance.AccountReceivable.DeleteChequeDocument.IResponse;
type Headers = Api.Finance.AccountReceivable.DeleteChequeDocument.IHeaders;
const url = '/api/Finance/AccountReceivable/:id/DeleteChequeDocument/:fileId';
export default async function accountReceivableDeleteChequeDocumentApi(
  id: number,
  fileId: number
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    url: createPathFromRoute(url, { id, fileId }),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
